"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SectionContent = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Section = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Section.css") : void 0);
const _excluded = ["className", "children"];
const CSS_BLOCK = 'sapcnqr-section';
const SectionContent = exports.SectionContent = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
      className,
      children
    } = props,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  const classnames = _bind.default.bind(_Section.default);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, otherProps, {
    className: classnames(CSS_BLOCK, `${CSS_BLOCK}__content`, className),
    ref: ref
  }), children);
});
SectionContent.displayName = 'Section.Content';
SectionContent.propTypes = {
  /** The content that will appear within the `<p>` tag. */
  children: _propTypes.default.node,
  /** Custom classes to add to the `<p>` tag. */
  className: _propTypes.default.string
};
var _default = exports.default = SectionContent;